module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Seller')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Product')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Promotions')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.t('7-Day sales')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "90px"
    }
  }, [_vm._v(_vm._s(_vm.t('Price')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.seller_name))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('td', [(row.highlight_promo == 1) ? _c('img', {
      staticClass: "promo",
      attrs: {
        "src": require("../../assets/img/promotion_highlight.png"),
        "title": _vm.t('Highlighted')
      }
    }) : _vm._e(), _vm._v(" "), (row.featured_promo == 1) ? _c('img', {
      staticClass: "promo",
      attrs: {
        "src": require("../../assets/img/promotion_featured.png"),
        "title": _vm.t('Featured')
      }
    }) : _vm._e(), _vm._v(" "), (row.bold_promo == 1) ? _c('img', {
      staticClass: "promo",
      attrs: {
        "src": require("../../assets/img/promotion_strong.png"),
        "title": _vm.t('Bold')
      }
    }) : _vm._e(), _vm._v(" "), (row.categories_promo == 1) ? _c('img', {
      staticClass: "promo",
      attrs: {
        "src": require("../../assets/img/promotion_category.png"),
        "title": _vm.t('Highlighted on category page')
      }
    }) : _vm._e(), _vm._v(" "), (row.homepage_promo == 1) ? _c('img', {
      staticClass: "promo",
      attrs: {
        "src": require("../../assets/img/promotion_homepage.png"),
        "title": _vm.t('Highlihted on homepage')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.quantity_sold_per_week))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.price))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e7c108d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YourAllegroComparison/details.vue
// module id = 1356
// module chunks = 2